import { ItemModel } from "./item";
import { ItemBrandModel } from "./item-brand";
import { ItemUnitModel } from "./item-unit";
import { SaleOrderDeliveryModel } from "./sale-order-delivery";
import { SaleOrderDeliveryDetailModel } from "./sale-order-delivery-detail";
import { SaleOrderDetailModel } from "./sale-order-detail";
import { SaleOrderModel } from "./sale-orders";

export const SaleOrderInvoiceDetailModel = {
    sale_order_id: 0,
    sale_order: SaleOrderModel,
    sale_order_detail: SaleOrderDetailModel,
    sale_order_delivery_id: 0,
    sale_order_delivery: SaleOrderDeliveryModel,
    sale_order_delivery_detail_id: 0,
    sale_order_delivery_detail: SaleOrderDeliveryDetailModel,
    invoice_quantity: 0,
    delivering_quantity: 0,
    invoice_total: 0,
    discount_rate: 0,
    discount_amount: 0,
    total_price: 0,
    tax_amount: 0,
    tax_rate: 0,
    net_total: 0,
}

export const SaleOrderInvoiceDetailParseArray = (data) => {
    const out = []
    const record = [...data]
    record.map((item) => out.push({ ...SaleOrderInvoiceDetailModel, ...item }))

    return out
}